if (!customElements.get('velora-product-video')) {
  customElements.define('velora-product-video', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.label = this.querySelector('.velora-video__label');
      this.icon = this.querySelector('.velora-video__icon');
      this.status = this.querySelector('.velora-video__status');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.loaded = false;
      this.inView = false;
      this.userPaused = false;
      this.manual = false;
      this.blocked = false;
      this.video.muted = true;
      this.video.controls = false;
      this.button.hidden = false;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.button.addEventListener('click', () => {
        if (!this.video.paused) {
          this.userPaused = true;
          this.manual = false;
          this.video.pause();
        } else {
          this.userPaused = false;
          this.manual = true;
          this.blocked = false;
          this.start(true);
        }
      }, options);
      this.video.addEventListener('play', () => this.sync(true), options);
      this.video.addEventListener('pause', () => this.sync(false), options);
      this.video.addEventListener('error', () => {
        this.blocked = true;
        this.video.pause();
        this.status.textContent = this.dataset.errorLabel;
        this.sync(false);
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video.pause();
        else this.update();
      }, options);
      this.motion.addEventListener('change', () => {
        this.manual = false;
        this.video.pause();
        this.update();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          const entry = entries[entries.length - 1];
          this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.35;
          if (!this.inView) this.video.pause();
          else this.update();
        }, { threshold: [0, 0.35, 0.7] });
        this.observer.observe(this.video);
      }
      this.sync(false);
    }
    load() {
      if (this.loaded) return;
      this.loaded = true;
      this.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      this.video.load();
    }
    update() {
      if (this.inView && !document.hidden && !this.userPaused && !this.blocked && (!this.motion.matches || this.manual)) this.start(false);
    }
    start(manual) {
      this.load();
      this.video.muted = true;
      const attempt = this.video.play();
      if (attempt) attempt.then(() => {
        if (document.hidden || (!manual && !this.inView)) this.video.pause();
      }).catch(() => {
        this.blocked = true;
        this.sync(false);
      });
    }
    sync(playing) {
      this.dataset.state = playing ? 'playing' : 'paused';
      const text = playing ? this.dataset.pauseLabel : this.dataset.playLabel;
      this.button.setAttribute('aria-label', text);
      this.button.setAttribute('aria-pressed', String(playing));
      this.label.textContent = text;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      this.video?.pause();
      this.bound = false;
    }
  });
}
